import { gql } from '@apollo/client';

export const GET_CUSTOM_FIELD_GROUPS = gql`
  query GET_CUSTOM_FIELD_GROUPS($entityType: CustomFieldDefinitionEntityTypeModel) {
    groups: customFieldDefinitionGroups(entityType: $entityType) {
      customFieldDefinitionGroups {
        name
        uid
        customResourcePermissions
      }
    }
  }
`;

export const CREATE_CUSTOM_FIELD_GROUP = gql`
  mutation CREATE_CUSTOM_FIELD_GROUP($customFieldDefinitionGroup: CustomFieldDefinitionGroupModelInput!) {
    group: createCustomFieldDefinitionGroup(customFieldDefinitionGroup: $customFieldDefinitionGroup) {
      name
      uid
      entityType
    }
  }
`;
